import { FC } from 'react'
import * as styles from 'styles/atoms/preloaders/DefaultPreloader.css'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'

type DefaultPreloaderProps = {
  isTransparent?: boolean
}

export const DefaultPreloader: FC<DefaultPreloaderProps> = (props) => {
  const { isTransparent } = props

  return (
    <div className={ styles.defaultPreloader }>
      <LoadingOverlay isTransparent={ isTransparent } />
    </div>
  )
}

export default DefaultPreloader
